/** Tiny SVG sparkline — decorative trend only, not a chart widget. */

export function MiniSparkline({
  values,
  accent,
  label,
}: {
  values: number[];
  accent: string;
  label: string;
}) {
  if (values.length < 2) {
    return (
      <span className="text-[10px] text-[var(--shell-fg-subtle)]" aria-label={`${label}: no trend series`}>
        No series
      </span>
    );
  }
  const w = 72;
  const h = 22;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const pts = values
    .map((v, i) => {
      const x = (i / (values.length - 1)) * (w - 2) + 1;
      const y = h - 2 - ((v - min) / span) * (h - 4);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      role="img"
      aria-label={`${label} sparkline, ${values.length} points`}
      className="block shrink-0"
    >
      <polyline
        fill="none"
        stroke={accent}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        points={pts}
        opacity={0.9}
      />
    </svg>
  );
}
